import React from "react";
import "./DateInput.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as Info } from "../../../assets/images/info.svg";

const CustomInput = ({
  value,
  onClick,
  placeholder,
  readOnly,
  elemHeight,
  disabled,
}) => (
  <div
    className="custom-input"
    style={{
      height: `${elemHeight ? elemHeight : "48"}px`,
      backgroundColor: disabled ? "#e9e9e9" : "",
      // cursor: disabled ? "not-allowed" : "pointer",
    }}
  >
    <div className="input-icon-wrapper" onClick={onClick}>
      <input
        type="text"
        readOnly={readOnly}
        value={value}
        placeholder={placeholder}
        className="input-with-icon"
        style={{ textAlign: value ? "center" : "left" }} // <-- change here
      />
    </div>
  </div>
);

const DateInput = ({
  heading,
  value,
  onChange,
  readOnly,
  minDate,
  maxDate,
  height,
  error,
  disabled,
  style,
  popperPlacement = "bottom-start",
  usePortal = false,
  isCustom = false,
  tooltip,
}) => {
  const portalProps = usePortal
    ? {
        withPortal: true,
        portalId: "date-picker-portal",
        popperClassName: "date-picker-popper",
        popperContainer: (popper) => (
          <div style={{ zIndex: 4000, position: "relative" }}>{popper}</div>
        ),
      }
    : {};

  return (
    <div className="inputDateContainer" style={{ position: "relative" }}>
      {heading && (
        <div className="inputextElem" style={{ display: "flex", alignItems: "center" }}>
          {heading}
          {tooltip && (
            <Tooltip title={tooltip} placement="top">
              <IconButton size="small" style={{ padding: "2px", marginLeft: "2px" }}>
                <Info style={{ fontSize: 14, color: "#666" }} />
              </IconButton>
            </Tooltip>
          )}
          {heading === "Terms Expiry Date" && (
            <Tooltip
              title="T&C needs to be finalized by this time. Expiry Date & Time should be at least 3 hours from current time & must be at least 2 hours before the earliest start time"
              placement="top"
            >
              <IconButton size="small" style={{ padding: "2px", marginLeft: "2px" }}>
                <Info style={{ fontSize: 14, color: "#666" }} />
              </IconButton>
            </Tooltip>
          )}
          {heading === "Listing Expiry Date *" && (
            <Tooltip
              // title={`No further action will be allowed after expiry.Listing Expiry must be at least 4 ${isCustom ? "days" : "hours"} before the earliest start time.`}
              title="No further action will be allowed after expiry. Listing Expiry must be at least 2 hours before the earliest start time."
              placement="top"
            >
              <IconButton size="small" style={{ padding: "2px", marginLeft: "2px" }}>
                <Info style={{ fontSize: 14, color: "#666" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}
      <div
        style={{
          ...style,
          backgroundColor: disabled ? "#e9e9e9" : "",
        }}
        className="date-picker-container"
      >
        <DatePicker
          selected={value}
          onChange={(date) => onChange(date)}
          placeholderText="DD-MM-YYYY"
          customInput={
            <CustomInput
              disabled={disabled}
              readOnly={readOnly}
              elemHeight={height}
              placeholder="DD-MMM-YYYY"
            />
          }
          dateFormat="dd-MMM-yyyy"
          showYearDropdown
          showMonthDropdown
          scrollableMonthYearDropdown
          minDate={minDate ? new Date(minDate) : undefined}
          maxDate={maxDate ? new Date(maxDate) : undefined}
          popperPlacement={popperPlacement}
          popperProps={{
            strategy: "fixed",
            modifiers: [
              {
                name: "zIndex",
                enabled: true,
                phase: "write",
                fn: ({ state }) => {
                  if (state?.styles?.popper) {
                    state.styles.popper.zIndex = 9999;
                  }
                  return state;
                },
              },
              {
                name: "preventOverflow",
                options: {
                  boundary: "viewport",
                },
              },
              {
                name: "flip",
                options: {
                  fallbackPlacements: ["bottom", "top"],
                },
              },
            ],
          }}
          disabled={disabled}
          {...portalProps}
        />
      </div>
      {error && <div className="dateErrorHeading">{error}</div>}
    </div>
  );
};

export default DateInput;
